import React from 'react'

import { Send } from 'lucide-react';
const ButtonSubmit = () => {
  return (
    <button
      type="submit"
      className="w-full bg-purple-600 text-white py-3 px-6 rounded-lg hover:bg-purple-700 transition-colors flex items-center justify-center space-x-2"
    >
      <Send className="w-5 h-5" />
      <span>Kirim Pesan</span>
    </button>
  )
}

export default ButtonSubmit